'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './baypass.routes';

export class BaypassComponent {
  /*@ngInject*/
  constructor($http,$scope) {
    // Load base modules 
    this.$http = $http;
    this.$scope = $scope;

/**
     * Function for updating charts
     * Parameters: startDate (from text input id=start | id=end and ng-model=startDate | endDate)
     * Response: response.data (A url for the embedded iframe using county paramter)
     */
$scope.updateCharts = function(){
    
  if(!$scope.startDate){
    $scope.startDate = document.getElementById('start').value;
  } else {
    $scope.startDate = $scope.startDate;
  } 

  if(!$scope.endDate){
    $scope.endDate = document.getElementById('end').value;
  } else {
    $scope.endDate = $scope.endDate;
  } 

  $scope.params = {
    startDate: $scope.startDate.toISOString().split('T')[0],
    endDate: $scope.endDate.toISOString().split('T')[0]
  }

  console.log($scope.params);
  
$http.post('/api/data/baypass/params', $scope.params)
.then(function (response) {
  console.log(response.data);
  // Reload iFrame with updated URL 
  document.getElementById('wleFrame').src = response.data;
  
 
})
.catch(function (error) {
  console.log(error);
})
}


  }

  $onInit() {
    //Create local instance of $http
   var http = this.$http;

   // Initialize select boxes 
   $('#multiSelect').select2();

   //Embed Iframe Function
   this.$scope.loadIframe = function(){
      var startDate = '2022-10-01';
      var endDate = '2022-12-31';

     http.get('/api/data/baypass/' + startDate + '/' + endDate)
       .then(function (response) {
         // console.log(response.data);
         document.getElementById('wleFrame').src = response.data;
         // document.getElementById('start').value = startDate;
         // document.getElementById('end').value = endDate;
       })
       .catch(function (error) {
         console.log(error);
       })
   }
   // Run the embed function 
   this.$scope.loadIframe();
 }
}

export default angular.module('appApp.baypass', [uiRouter])
  .config(routes)
  .component('baypass', {
    template: require('./baypass.html'),
    controller: BaypassComponent,
    controllerAs: 'baypassCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/baypass/baypass.component.js